<template>
  <div class="container z-depth-1 mt-5 p-lg-5">
    <!-- Section -->
    <section class="about-service">
      <h2 class="font-weight-bold text-center section-title pb-2">
        Les atouts de Livratos
      </h2>
      <hr class="w-header my-4" />
      <p class="lead text-center section-lead pt-2 mb-5">
        Une plateforme pensée pour la <strong>logistique BTP</strong>&nbsp;:
        visibilité, contrôle et exécution alignés sur la réalité du terrain.
      </p>

      <div class="row d-flex justify-content-center px-3">
        <div class="col-md-6 col-xl-4 slide-left">
          <h3 class="font-weight-normal service-title">Vision temps réel</h3>
          <p class="small service-tag">
            Courses, statuts, <strong>chantiers</strong>
          </p>
        </div>

        <div class="col-md-6 slide-right">
          <p class="service-text mb-5 pb-2">
            Tableau de bord unifié, statuts de courses (en attente, en transit,
            <strong>livrées</strong>, interrompues): Livratos vous donne une vue
            claire sur ce qui circule, où, et pour qui, sans devoir courir après
            l’information.
          </p>
        </div>

        <div class="col-md-6 col-xl-4 slide-left">
          <h3 class="font-weight-normal service-title">Volume optimisé</h3>
          <p class="small service-tag">3D, Best Fit, bon véhicule</p>
        </div>

        <div class="col-md-6 slide-right">
          <p class="service-text mb-5 pb-2">
            Visualisation 3D du chargement, sélection d’objets (colis, palettes,
            sacs, barres) et algorithme Best Fit&nbsp;: Livratos vous aide à
            remplir intelligemment le véhicule et à choisir le bon format pour
            éviter de payer un camion surdimensionné.
          </p>
        </div>

        <div class="col-md-6 col-xl-4 slide-left">
          <h3 class="font-weight-normal service-title">Moins d’imprévus</h3>
          <p class="small service-tag">Express & programmées cadrées</p>
        </div>

        <div class="col-md-6 slide-right">
          <p class="service-text mb-5 pb-2">
            Courses express, <strong>livraisons</strong> programmées, infos
            claires sur le chargement et le véhicule&nbsp;: Livratos réduit les
            quiproquos, les allers-retours inutiles et les
            <strong>chantiers</strong> à l’arrêt faute de matériel au bon
            moment.
          </p>
        </div>

        <div class="col-md-6 col-xl-4 slide-left">
          <h3 class="font-weight-normal service-title">Dernier kilomètre</h3>
          <p class="small service-tag">Critique en BTP</p>
        </div>

        <div class="col-md-6 slide-right">
          <p class="service-text mb-5 pb-2">
            Le <strong>dernier kilomètre en BTP</strong> n’a rien d’un simple
            trajet final. Accès difficiles, engins présents, zones restreintes,
            horaires serrés&nbsp;: Livratos structure ce segment critique pour
            garantir des <strong>livraisons</strong> fiables jusqu’au pied du
            chantier, là où chaque minute compte réellement.
          </p>
        </div>
      </div>
    </section>
    <!-- Section -->
  </div>
</template>

<script>
export default {
  name: "AdvantageSection",
};
</script>

<style lang="scss" scoped>
.about-service {
  .section-title {
    color: $color-text;
  }

  .section-lead {
    color: $color-text-grey;
    font-size: 1.05rem;
  }

  .service-title {
    color: $color-primary;
  }

  .service-tag {
    color: $color-text-grey;
    font-weight: bolder !important;
  }

  .service-text {
    color: $color-text-grey;
    font-size: 0.98rem;
    line-height: 1.6;
  }

  a {
    color: $color-primary;
  }
}
</style>
